import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import {
  JourneyPosition,
  OccupancyType,
  useYardSetupMessageHandler,
  useYardStores,
  YardPositionSelector,
} from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { ContainerTurnoverListViewStore } from '../../stores/container-turnover-list.view-store'

interface Props {
  listStore: ContainerTurnoverListViewStore
}
export const ContainerTurnoversUpdatePositionDialog = observer(({ listStore }: Props) => {
  const { t } = useTranslate()
  const { yardPositionSelectorStore } = useYardStores()

  const [journeyPosition, setJourneyPosition] = useState<JourneyPosition | undefined>(undefined)
  const [triedToSubmit, setTriedToSubmit] = useState(false)
  const { getExceptionMessage, getUpdatePositionSuccessMessage } = useYardSetupMessageHandler()

  const handleSubmit = async () => {
    try {
      setTriedToSubmit(true)

      if (!journeyPosition || !listStore.selectedJourneyId) return

      await yardPositionSelectorStore.stackInJourney(
        listStore.selectedJourneyId,
        listStore.selectedContainerNumber,
      )

      listStore.toggleUpdatePositionDialog()
      setJourneyPosition(undefined)
      setTriedToSubmit(false)

      appStore.setShowAlert('success', getUpdatePositionSuccessMessage())
    } catch (error) {
      appStore.setShowAlert('error', getExceptionMessage(error))
    }
  }

  return (
    <ConfirmationDialog
      open={listStore.isUpdatePositionDialogOpen}
      title={t('updatePositionFor', 'Update position for {containerNumber}', {
        containerNumber: listStore.selectedContainerNumber,
      })}
      primaryActionText={t('yesUpdate', 'Yes, update')}
      closeLabel={t('noCancel', 'No, cancel')}
      maxWidth='md'
      onClose={() => listStore.toggleUpdatePositionDialog()}
      onConfirm={handleSubmit}
    >
      <YardPositionSelector
        journeyId={listStore.selectedJourneyId ?? 0}
        prefillPosition={OccupancyType.Occupied}
        hasError={triedToSubmit && !journeyPosition}
        onChange={position => setJourneyPosition(position)}
      />
    </ConfirmationDialog>
  )
})
